document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.advent-embark');
  const mobileContainer = root.querySelector('.advent-embark__mobile');
  const mobileTitle = root.querySelector('.advent-embark__mobile-title');
  const stickyButton = document.querySelector('.sticky-quick-add');
  const embarkSection = root.closest('[id^="shopify-section-"]');
  let nextSection = embarkSection ? embarkSection.nextElementSibling : null;

  while (nextSection && !nextSection.id?.startsWith('shopify-section-')) {
    nextSection = nextSection.nextElementSibling;
  }

  const lottieElement = root.querySelector('#adventLottie');
  const lottiePlayer = lottieElement.getLottie();

  // Basic logic: We set the target frame according to the user's scroll position, but scroll events are triggered somewhat unreliably,
  // so I've added a smoothAnimation function that updates the frames at a locked 60fps to guarantee smooth behavior.
  let targetFrame = lottiePlayer.currentFrame || 0;
  let currentFrame = targetFrame;

  let adventBannerVisible = false;
  function updateSticky() {
    if (!stickyButton || !mobileContainer) return;

    const viewportHeight = window.innerHeight;
    const animationRect = mobileContainer.getBoundingClientRect();
    const isBeforeAnimationBlock = animationRect.top >= viewportHeight;
    const nextSectionRect = nextSection?.getBoundingClientRect();
    const hasNextSectionEnteredViewport = nextSectionRect
      ? nextSectionRect.top < viewportHeight
      : animationRect.bottom <= 0;

    if (
      !adventBannerVisible &&
      (isBeforeAnimationBlock || hasNextSectionEnteredViewport)
    ) {
      stickyButton.classList.add('sticky-mode-advent');
    } else {
      stickyButton.classList.remove('sticky-mode-advent');
    }
  }

  document.addEventListener('scroll', () => {
    const { top, height } = mobileContainer.getBoundingClientRect();
    if (height === 0) return;
    const current = window.innerHeight - top;

    const rawVisibility = current / height;
    if (rawVisibility > 0.7) {
      mobileTitle.classList.add('active');
    } else {
      mobileTitle.classList.remove('active');
    }

    const animationStart = 0.3;
    const animationEnd = 1.0;
    const animationProgress =
      (rawVisibility - animationStart) / (animationEnd - animationStart);
    const newTarget = lottiePlayer.totalFrames * animationProgress;

    targetFrame = Math.max(
      1,
      Math.min(lottiePlayer.totalFrames - 1, newTarget)
    );

    updateSticky();
  });

  window.addEventListener('resize', updateSticky);
  updateSticky();

  function smoothAnimationLoop() {
    const maxSpeed = 1;
    const delta = targetFrame - currentFrame;

    if (Math.abs(delta) <= maxSpeed) {
      currentFrame = targetFrame;
    } else {
      currentFrame += Math.sign(delta) * maxSpeed;
    }

    lottiePlayer.goToAndStop(currentFrame, true);
    requestAnimationFrame(smoothAnimationLoop);
  }
  smoothAnimationLoop();

  const desktopContainer = root.querySelector('.advent-embark__desktop');
  const desktopPoints = desktopContainer.querySelectorAll(
    '.advent-embark__desktop-point'
  );

  desktopPoints.forEach((item, index) => {
    item.addEventListener('mouseenter', () => {
      dataLayer.push({
        event: 'custom_event',
        event_name: 'advent_calendar_interactive_block_product_view',
        parameter: JSON.stringify({
          content_number: `${index + 1}`
        })
      });
    });
  });

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          (function () {
            desktopPoints.forEach((element, index) => {
              setTimeout(() => {
                element.classList.add('active');
              }, index * 50);
            });
          })();
          observer.disconnect();
        }
      });
    },
    {
      root: null,
      rootMargin: '0px',
      threshold: 0.5
    }
  );
  observer.observe(desktopContainer);

  const productAdventBanners = document.querySelectorAll(
    '.product-advent-banner'
  );
  const adventBannerObserver = new IntersectionObserver(
    entries => {
      adventBannerVisible = entries.some(
        e => e.isIntersecting && e.intersectionRatio > 0
      );
      updateSticky();
    },
    { threshold: [0, 0.01, 0.1] }
  );
  productAdventBanners.forEach(el => adventBannerObserver.observe(el));
});
